import React from 'react';
import LazyLoad, { LazyLoadProps } from 'react-lazyload';
import { CSSTransition } from 'react-transition-group';

type ImgProps = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export function LazyImage(props: ImgProps & LazyLoadProps) {
  return (
    <LazyLoad {...props as LazyLoadProps} debounce={false} once offset={500}>
      <CSSTransition in={true} appear={true} timeout={1200} classNames="js-fade">
        <img {...props as ImgProps} />
      </CSSTransition>
    </LazyLoad>
  );
}
